import { useEffect } from "react";

import { getLabel } from "../../../hooks/use-labels";
import { removeLocalStorageItems } from "../../../utils/common-utils";
import useUser from "../../../features/profile/useUser";
import EmptyOrderView from "./EmptyOrderView";
import OrdersList from "./OrdersList";

import "./style.css";

const ConsumerOrders = () => {
  const { isAuthenticated: activeUser } = useUser();

  useEffect(() => {
    removeLocalStorageItems(["redirectPath"]);
  }, []);

  return (
    <div className="ord-screen">
      <header className="ord-pagehead">
        <h1 className="ord-pagetitle">{getLabel("myOrdersLabel")}</h1>
      </header>

      {!activeUser ? <EmptyOrderView /> : <OrdersList />}
    </div>
  );
};

export default ConsumerOrders;
